import { fetchSettings } from 'ducks/settings';
const loadData = ({ store }) => store.dispatch(fetchSettings());
export default loadData;
